import { BadImplementationException } from '@nu-art/ts-common';
const extractElement = (element) => {
    return element instanceof HTMLElement ? element : element.current;
};
export const scrollIntoView = (_child, _container, scrollBehavior = 'smooth') => {
    const child = extractElement(_child);
    const container = extractElement(_container);
    if (!child || !container)
        throw new BadImplementationException('Got no elements');
    const childRect = child.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();
    const inView = (childRect.top >= containerRect.top) && (childRect.bottom <= containerRect.top + container.clientHeight);
    if (!inView) {
        const scrollTop = childRect.top - containerRect.top;
        const scrollBot = childRect.bottom - containerRect.bottom;
        let scroll = container.scrollTop;
        if (Math.abs(scrollTop) < Math.abs(scrollBot))
            scroll += scrollTop - 35;
        else
            scroll += scrollBot;
        container.scroll({ top: scroll, behavior: scrollBehavior });
    }
};
export const scrollIntoView_Horizontal = (_child, _container, scrollBehavior = 'smooth') => {
    const child = extractElement(_child);
    const container = extractElement(_container);
    if (!child || !container)
        throw new BadImplementationException('Got no elements');
    const childRect = child.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();
    const inView = (childRect.left >= containerRect.left) && (childRect.right <= containerRect.left + container.clientWidth);
    if (!inView) {
        const scrollLeft = childRect.left - containerRect.left;
        const scrollRight = childRect.right - containerRect.right;
        let scroll = container.scrollLeft;
        if (Math.abs(scrollLeft) < Math.abs(scrollRight))
            scroll += scrollLeft - 35;
        else
            scroll += scrollRight;
        container.scroll({ left: scroll, behavior: scrollBehavior });
    }
};
export const scrollToTop = (_child, _container, scrollBehavior = 'smooth', offset = 0) => {
    const child = extractElement(_child);
    const container = extractElement(_container);
    if (!child || !container)
        throw new BadImplementationException('Got no elements');
    const childRect = child.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();
    if (childRect.top === containerRect.top)
        return;
    let scroll = container.scrollTop;
    scroll += childRect.top - containerRect.top - offset;
    container.scroll({ top: scroll, behavior: scrollBehavior });
};
export const scrollToMiddle_Vertical = (_child, _container, scrollBehavior = 'smooth', offset = 0) => {
    const child = extractElement(_child);
    const container = extractElement(_container);
    if (!child || !container)
        throw new BadImplementationException('Got no elements');
    const childRect = child.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();
    const childMidPoint = childRect.y + (childRect.height / 2);
    const containerMidPoint = containerRect.y + (containerRect.height / 2);
    if (childMidPoint === containerMidPoint)
        return;
    let scroll = container.scrollTop;
    scroll += childMidPoint - containerMidPoint - offset;
    container.scroll({ top: scroll, behavior: scrollBehavior });
};
//# sourceMappingURL=scroll-into-view.js.map